var render = function render(){var _vm=this,_c=_vm._self._c;return _c('articles-chooser',{staticClass:"my-3",model:{value:(_vm.articles),callback:function ($$v) {_vm.articles=$$v},expression:"articles"}})
}
var staticRenderFns = []

export { render, staticRenderFns }